export default __webpack_public_path__ + "static/media/company_robot.160fa201.svg";